      <div class="col-md-10">
      <h3>Reset the Individual password</h3>
          
      <form *ngIf="!success" (ngSubmit)="resetPassword()" #indResetPassword="ngForm" autocomplete="off" >
            <div class="form-group">
                  <label for="firstname" i18n="@@lblFirstName"> First Name : </label>
                  <label id="firstname" > {{model.firstname}} </label>
            </div>          
            <div class="form-group">
                  <label for="lastname" i18n="@@lblLastName"> Last Name : </label>
                  <label id="lastname" > {{model.lastname}} </label>                  
            </div>                      
            <div class="form-group">
                  <label for="email" i18n="@@lblEmail"> Email : </label>
                  <label id="email" > {{model.email}} </label>                                    
            </div>
            <div class="form-group">
                  <label for="password" i18n="@@lblPwdMin">Password : (min 8 chars)</label>
                  <input type="password" class="form-control" id="password" name="password" autocomplete="off" [(ngModel)]="credentials.password" 
                  #password="ngModel" required validateEqual="password2"  reverse="true"  pattern=".{8,}">  
                  <div [hidden]="password.valid || password.pristine" class="alert alert-danger" i18n="@@valMin8PwdReqd">
                        Password is required (minimum length 8 characters).
                  </div>
            </div>
            <div class="form-group">
                  <label for="password2" i18n="@@lblReenterPwd">Re-enter Password : </label>
                  <input type="password" class="form-control" id="password2" name="password2" autocomplete="off" [(ngModel)]="credentials.password2" 
                  #password2="ngModel" required validateEqual="password"  reverse="false" >  
                  <div [hidden]="(password2.valid && (password.value === password2.value)) || password2.pristine" class="alert alert-danger" i18n="@@valReenterPwd">
                        Re enter Password does not match the Password entered above.
                  </div>
            </div>           
            <!--<button type="submit" class="btn btn-primary" [disabled]="!indResetPassword.valid || loading" i18n="@@btnSubmit">Submit</button>-->
            <button type="submit" class="btn btn-primary" [disabled]="!indResetPassword.valid || loading" ><span i18n="@@btnSubmit"> Submit </span> <i *ngIf="loading" class="fa fa-spinner fa-pulse"></i></button>
            <a  *ngIf="!loading" [routerLink]="['/ind-login']" class="btn btn-link" i18n="@@btnCancel">Cancel</a>            
      </form>

      </div>